export default __webpack_public_path__ + "static/makecode_16x_white-a17a2c5c44db07b5cecb1560f991c7d3.svg";